/* -------------------------------------------------------------------------- */
/*                               Schema Customers                             */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const office = new schema.Entity('offices', {}, { idAttribute: 'officeId' });
export const offices = new schema.Array(office);
